module.exports = __webpack_public_path__ + "static/media/arrow-up.b357d184.svg";